import { z } from 'zod'
import { containsNewLine } from '@App/helpers/work-entities-fields-validators'
import {
    integerMessage,
    newlineMessage,
    numericMessage,
    requiredMessage,
    stringMessage,
    stringSizeBetweenMessage,
} from '@Entities/schemas/work/error-messages'

const alternativeTitleSchema = z.object({
    id: z.number().int(integerMessage('ID')).optional().nullable(),
    localId: z.number().int(integerMessage('Local ID')).optional().nullable(),
    title: z
        .string({
            error: (issue) =>
                issue.received === 'undefined'
                    ? requiredMessage('Alternative title')
                    : stringMessage('Alternative title'),
        })
        .min(1, stringSizeBetweenMessage('Alternative title', 1, 500))
        .max(500, stringSizeBetweenMessage('Alternative title', 1, 500))
        .refine((val) => !containsNewLine(val), newlineMessage('Alternative title')),
    titleType: z
        .number({
            error: (issue) =>
                issue.received === 'undefined' ? requiredMessage('Title type') : numericMessage('Title type'),
        })
        .int(integerMessage('Title type')),
    languageCode: z.number().int(integerMessage('Language code')).nullable(),
})

export type AlternativeTitleSchema = z.infer<typeof alternativeTitleSchema>

export default alternativeTitleSchema
